import { typePrefix } from "./helpers";

export const ACTIVE_STATUS_ON_CHANGE = typePrefix("ON_CHANGE");
